/* tslint:disable */
/* eslint-disable */
/**
 * Melco Digitizing APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse
 */
export interface DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse {
    /**
     * 
     * @type {string}
     * @memberof DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse
     */
    measurement_unit?: string | null;
}

export function DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseFromJSON(json: any): DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse {
    return DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseFromJSONTyped(json, false);
}

export function DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'measurement_unit': !exists(json, 'measurement_unit') ? undefined : json['measurement_unit'],
    };
}

export function DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponseToJSON(value?: DigitizingserviceMelcoDigitizingModelsDefaultMeasurementUnitResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'measurement_unit': value.measurement_unit,
    };
}


